import { StylovyzeTableHeaderProps } from '@innovyze/stylovyze';

export const EDIT_SENSOR_DATA_HEADER: StylovyzeTableHeaderProps[] = [
	{
		key: 'dataEditor-dateTime',
		cell: 'Date/Time',
		align: 'left',
		sortable: true,
	},
	{
		key: 'dataEditor-curValue',
		cell: 'Current Value',
		align: 'left',
		sortable: true,
	},
	{
		key: 'dataEditor-newValue',
		cell: 'New Value',
		align: 'left',
	},
	{
		key: 'dataEditor-delete',
		cell: '',
		align: 'left',
		width: '50px',
	},
];
